module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.paginatedCustomers,
      "stripe": "",
      "border": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "empty"
    },
    slot: "empty"
  }, [_vm._v("\n      Aucune donnée\n    ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Nom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('customer', {
          attrs: {
            "item": scope.row
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Suivi commercial"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.loadingReminders) ? _c('div', [_c('pulse-loader', {
          attrs: {
            "color": "#cccccc",
            "size": "8px"
          }
        })], 1) : _c('div', [(_vm.models.reminders.find(function (reminder) { return reminder.customer_id === scope.row.id; })) ? _c('div', [_c('reminder', {
          attrs: {
            "item": _vm.models.reminders.find(function (reminder) { return reminder.customer_id === scope.row.id; })
          }
        }), _vm._v("\n            ("), _c('user', {
          attrs: {
            "item": _vm.users.find(function (user) { return user.id === _vm.models.reminders.find(function (reminder) { return reminder.customer_id === scope.row.id; }).user_id; })
          }
        }), _vm._v(")\n          ")], 1) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "text-muted font-13"
        }, [_c('strong', [_vm._v("Dans le parc de ")]), _vm._v(" :\n          "), (scope.row.user_id) ? _c('span', [_c('user', {
          attrs: {
            "item": _vm.users.find(function (user) { return user.id === scope.row.user_id; })
          }
        })], 1) : _c('span', [_vm._v("\n                  Aucun\n                ")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Dernier contact"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.loadingCalls) ? _c('div', [_c('pulse-loader', {
          attrs: {
            "color": "#cccccc",
            "size": "8px"
          }
        })], 1) : _c('div', [_c('last-call-widget', {
          attrs: {
            "last_call": _vm.models.calls.filter(function (call) { return call.customer_id === scope.row.id; }).pop()
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Contacts"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('customer', {
          attrs: {
            "present": "contacts",
            "item": scope.row
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Services"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('customer', {
          attrs: {
            "present": "services",
            "item": scope.row
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.pagination.current_page,
      "page-size": _vm.pagination.per_page,
      "layout": "total, prev, pager, next",
      "total": _vm.pagination.total
    },
    on: {
      "current-change": _vm.currentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b394d18a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Entities/Tables/CustomersTable.vue
// module id = 720
// module chunks = 1